import React, { Component } from 'react';

import NewsCard from '../../components/NewsCard'
import MiniPaginationCustom from '../../components/default/MiniPaginationCustom'

import { connect } from 'react-redux'
import { fetchNewsList } from '../../actions/newsList'

class NewsList extends Component {
    state = {
        start: 0,
        end: 15
    }

    componentDidMount = () => {
        this.props.fetchNewsList()
    }

    onPageChange = (page, pageSize) => {
        const start = (page - 1) * pageSize
        const end = start + pageSize
        this.setState({ start, end })
    }

    render() {
        if(Object.keys(this.props.newsList).length > 0){
            return (
                <div className="page-list-wrap">
                    <div className="page-list">
                        <div className="page-list-title gapb-24">ข่าวสาร<div className="hr"></div></div>     
                        <div className="is-row gapb-16 gapr--16 sm-gapr-0 flex-wrap">
                            {
                                this.props.newsList.slice(this.state.start, this.state.end).map((news, index) => (
                                    <NewsCard key={index} news={news}/>
                                ))
                            }
                        </div>
                        <div className="textAlign-center">
                            <MiniPaginationCustom 
                                color="blue"
                                total={this.props.newsList.length} 
                                defaultPageSize={15}
                                onChange={this.onPageChange}
                            />
                        </div>
                    </div>
                </div>
            )
        } else{
            return null
        }
    }
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		user: state.user,
		newsList: state.newsList
	}
}

const mapDispatchToProps = {
	fetchNewsList
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsList)
